import { useRef, useState } from 'react';

import { CREHANA_BASE_URL_PRD } from '@crehana/constants';
import { useTranslation } from '@crehana/i18n';
import Facebook from '@crehana/icons/Facebook';
import Linkedin from '@crehana/icons/Linkedin';
import Share from '@crehana/icons/Share';
import Twitter from '@crehana/icons/Twitter';
import Popper from '@crehana/ui/dist/Popper';
import { primaryMain } from '@crehana/ui/dist/styles/colors';
import copy from 'copy-to-clipboard';

const ShareLinks = () => {
  const { t } = useTranslation();

  const [copied, setCopied] = useState(false);
  const shareRef = useRef(null);

  const onCopy = () => {
    setCopied(true);
    copy(window.location.href);

    setTimeout(() => {
      setCopied(false);
    }, 1000);
  };

  return (
    <div>
      <div
        className="flex flex-col items-center justify-center w-full bg-white rounded-5 pb-32"
        css={`
          @media (min-width: 768px) {
            box-shadow: 0px 4px 18px rgba(92, 84, 122, 0.14);
          }
        `}
      >
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${CREHANA_BASE_URL_PRD}/cupones/`}
          target="_blank"
          rel="noreferrer"
          className="mt-32"
        >
          <Facebook size={24} color={primaryMain} />
        </a>
        <a
          href={`https://www.linkedin.com/shareArticle?mini=true&url=${CREHANA_BASE_URL_PRD}/cupones/`}
          target="_blank"
          rel="noreferrer"
          className="mt-32"
        >
          <Linkedin size={24} color={primaryMain} />
        </a>
        <a
          href={`https://twitter.com/intent/tweet?url=${CREHANA_BASE_URL_PRD}/cupones/&text=`}
          target="_blank"
          rel="noreferrer"
          className="mt-32"
        >
          <Twitter size={24} color={primaryMain} />
        </a>
        <button
          type="button"
          ref={shareRef}
          className="mt-32 cursor-pointer"
          onClick={onCopy}
        >
          <Share size={24} color={primaryMain} />
        </button>
        <Popper
          anchorRef={shareRef}
          isVisible={copied}
          dismissOnClickOutside
          onDismiss={() => setCopied(false)}
          position="right"
        >
          <div className="bg-black py-4 px-8">
            <p className="font-caption text-white">
              {t('SHARE_LINKS_COPY_CONFIRMATION', '¡Link copiado!')}
            </p>
          </div>
        </Popper>
      </div>
      <p className="text-gray-dark font-caption text-center mt-8">
        {t('SHARE_LINKS_SHARE', 'Compartir')}
      </p>
    </div>
  );
};

export default ShareLinks;
